(function () {
  'use strict';

  // Optional fields still use native validation when filled. Reveal a folded
  // field before the browser focuses it; leave the validation and submit alone.
  document.addEventListener('invalid', function (event) {
    var field = event.target;
    if (!field || typeof field.closest !== 'function') return;
    var details = field.closest('details.oxp-project-details');
    if (!details || !details.closest('.oxp-contact-page')) return;
    details.open = true;
  }, true);
})();
